// extracted by mini-css-extract-plugin
export default {"search-input":"Search_search-input__Kxz61"};